import { useEffect } from 'react';

const FB_PIXEL_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

// 延後載入 FB Pixel：原本用 next/head 在 SSR 階段就注入 inline script
// 改成掛載後在瀏覽器空檔 (requestIdleCallback) 才注入 + init + PageView，讓它離開初始解析路徑
const FBPixelCode = ({ pixelId }) => {
	useEffect(() => {
		if (!pixelId || typeof window === 'undefined') return undefined;

		const init = () => {
			if (window.fbq) return;
			/* eslint-disable */
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      }(window, document, 'script', FB_PIXEL_SRC);
      /* eslint-enable */
			window.fbq('init', pixelId);
			window.fbq('track', 'PageView');
		};

		const ric = window.requestIdleCallback || (cb => window.setTimeout(cb, 2000));
		const id = ric(init);

		return () => {
			if (window.cancelIdleCallback && typeof id === 'number') {
				window.cancelIdleCallback(id);
			}
		};
	}, [pixelId]);

	return null;
};

export default FBPixelCode;
